import { render, staticRenderFns } from "./GenitoreClasseDettaglio.vue?vue&type=template&id=5f0cca8a"
import script from "./GenitoreClasseDettaglio.vue?vue&type=script&lang=js"
export * from "./GenitoreClasseDettaglio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports